'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Avatar = require('./Avatar');

var _Avatar2 = _interopRequireDefault(_Avatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Avatar2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/Avatar/index.js
 ** module id = 419
 ** module chunks = 0
 **/